module.exports = __webpack_public_path__ + "img/btn_wallpaper1_thumb.98be8f89.png";